import { Navigate, Route, Routes, useLocation } from "react-router";

import { AdminRoute, ProtectedRoute } from "@/components/protected-route";
import { AdminActivityPage } from "@/features/admin/activity";
import { AdminUsersPage } from "@/features/admin/users";
import { ApprovalsPage } from "@/features/approvals";
import { HomePage } from "@/features/home";
import { LoginPage } from "@/features/login";
import { NotFoundPage } from "@/features/not-found";
import { ProfilePage } from "@/features/profile";
import { SignupPage } from "@/features/signup";
import { UsagePage } from "@/features/usage";
import { VerifyEmailPage } from "@/features/verify-email";

/**
 * `/` forwards to `/home`, except when Supabase redirected an OAuth `?code=`
 * to the site root: then the query goes to `/login`, which exchanges it.
 */
function RootRedirect() {
  const { search } = useLocation();
  const hasCode = new URLSearchParams(search).has("code");
  return <Navigate to={hasCode ? `/login${search}` : "/home"} replace />;
}

export function App() {
  return (
    <Routes>
      <Route path="/" element={<RootRedirect />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/signup" element={<SignupPage />} />
      <Route path="/verify-email" element={<VerifyEmailPage />} />
      <Route element={<ProtectedRoute />}>
        <Route path="/home" element={<HomePage />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/approvals" element={<ApprovalsPage />} />
        <Route path="/usage" element={<UsagePage />} />
      </Route>
      <Route element={<AdminRoute />}>
        <Route path="/admin/users" element={<AdminUsersPage />} />
        <Route path="/admin/activity" element={<AdminActivityPage />} />
      </Route>
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
